/** An array of team members, mainly for the about us page, but also used for employee count around the site */
export const teamMembers = [
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/andrew.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/andrew-travel.jpg`,
    name: 'Andrew',
    linkedInLink: 'https://www.linkedin.com/in/abroekelmann/',
    jobTitle: 'Co-founder & CEO',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/lisa.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/lisa-travel.jpg`,
    name: 'Lisa',
    linkedInLink: 'https://www.linkedin.com/in/lisanederveen/',
    jobTitle: 'Co-founder & COO',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/callum.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/callum-travel.jpg`,
    name: 'Callum',
    linkedInLink: 'https://www.linkedin.com/in/callum-wright-230a4574/',
    jobTitle: 'Co-founder & UX/UI Designer',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/violet.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/violet-travel.jpg`,
    name: 'Violet',
    linkedInLink: 'https://www.linkedin.com/in/violet-currey-302362a1/',
    jobTitle: 'Customer Success Manager',
  },

  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/reshat.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/reshat-travel.jpg`,
    name: 'Reshat',
    linkedInLink: 'https://linkedin.com/in/re%C5%9Fat-serpek-6b9232182/',
    jobTitle: 'Full Stack Developer',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/tim.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/tim-travel.jpg`,
    name: 'Tim',
    linkedInLink: 'https://www.linkedin.com/in/timothy-lui/',
    jobTitle: 'CTO',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/kayne.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/kayne-travel.jpg`,
    name: 'Kayne',
    linkedInLink: 'https://www.linkedin.com/in/kayne-chung/',
    jobTitle: 'Backend Developer',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/jordan.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/jordan-travel.jpg`,
    name: 'Jordan',
    linkedInLink:
      'https://www.linkedin.com/in/jordan-johnston-teggart-537895216/',
    jobTitle: 'Customer Success Team Lead',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/heenal.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/heenal-travel.jpg`,
    name: 'Heenal',
    linkedInLink: 'https://www.linkedin.com/in/heenal-vaghela-069011238/',
    jobTitle: 'Customer Success Agent',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/jasmine.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/jasmine-travel.jpg`,
    name: 'Jasmine',
    linkedInLink: 'https://www.linkedin.com/in/jasminebaragwanath/',
    jobTitle: 'Social Media Manager',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/luca.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/luca-travel.jpg`,
    name: 'Luca',
    linkedInLink: 'https://www.linkedin.com/in/luca-tsouloulis-a83487174/',
    jobTitle: 'Graphic designer',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/alice.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/alice-travel.jpg`,
    name: 'Alice',
    linkedInLink: 'https://www.linkedin.com/in/alicemarshall-1/',
    jobTitle: 'Senior Full Stack Developer',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/steve.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/steve-travel.jpg`,
    name: 'Steve',
    linkedInLink: 'https://www.linkedin.com/in/steven-c-bb1756157/',
    jobTitle: 'Lead Developer',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/sakinah.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/sakinah-travel.jpg`,
    name: 'Sakinah',
    linkedInLink: 'https://linkedin.com/in/sakinahpryce',
    jobTitle: 'Customer Success Agent',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/gabriele.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/gabriele-travel.jpg`,
    name: 'Gabriele',
    linkedInLink: 'https://www.linkedin.com/in/gabrielecorà/',
    jobTitle: 'Winner Manager',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/hollie.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/hollie-travel.jpg`,
    name: 'Hollie',
    linkedInLink: 'https://www.linkedin.com/in/hollie-peterson-502275234',
    jobTitle: 'Customer Success Agent',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/emily.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/emily-travel.jpg`,
    name: 'Emily',
    linkedInLink: 'https://www.linkedin.com/in/emily-henwood-marketing',
    jobTitle: 'CRM/Lifecycle Manager',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/diya.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/diya-travel.jpg`,
    name: 'Diya',
    linkedInLink: 'https://www.linkedin.com/in/diya-malhotra-5099242b6',
    jobTitle: 'Marketing Intern',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/kota.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/kota-travel.jpeg`,
    name: 'Kota',
    linkedInLink: 'https://www.linkedin.com/in/kotashibata',
    jobTitle: 'Senior Performance Marketing Lead',
  },
  {
    image: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/veronika.jpg`,
    funImage: `https://daymade-website-assets.s3.amazonaws.com/2026/about-us/team/veronika-travel.jpg`,
    name: 'Veronika',
    linkedInLink: 'https://www.linkedin.com/in/veronika-savikina/',
    jobTitle: 'Product Design Lead',
  },
];
export const teamMemberCount = teamMembers.length;
